import Vue from 'vue'
import Vuex from 'vuex'

import shared from "./shared";
import user from "./user";
import businesses from "./businesses";
import menu from "./menu";
import cart from "./cart";
import giftcard from "./giftcard";


Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    shared,
    user,
    businesses,
    menu,
    cart,
    giftcard
  }
})
